function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 0v28h28V0H0zm9.333 22.167h-3.5V9.333h3.5v12.834zM7.583 7.854a2.05 2.05 0 0 1-2.041-2.058 2.05 2.05 0 0 1 2.041-2.058 2.05 2.05 0 0 1 2.042 2.058 2.05 2.05 0 0 1-2.042 2.058zm15.75 14.313h-3.5v-6.538c0-3.93-4.666-3.632-4.666 0v6.538h-3.5V9.333h3.5v2.06c1.63-3.018 8.166-3.24 8.166 2.888v7.886z",
  fill: "url(#linkedin_svg__paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linkedin_svg__paint0_linear",
  x1: 0,
  y1: 0,
  x2: 28,
  y2: 28,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#77BDFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0E4EFF"
})));

var SvgLinkedin = function SvgLinkedin(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgc3R5bGU9Im1peC1ibGVuZC1tb2RlOmhhcmQtbGlnaHQiPgo8cGF0aCBkPSJNMCAwVjI4SDI4VjBIMFpNOS4zMzMzMyAyMi4xNjY3SDUuODMzMzNWOS4zMzMzM0g5LjMzMzMzVjIyLjE2NjdaTTcuNTgzMzMgNy44NTRDNi40NTYzMyA3Ljg1NCA1LjU0MTY3IDYuOTMyMzMgNS41NDE2NyA1Ljc5NkM1LjU0MTY3IDQuNjU5NjcgNi40NTYzMyAzLjczOCA3LjU4MzMzIDMuNzM4QzguNzEwMzMgMy43MzggOS42MjUgNC42NTk2NyA5LjYyNSA1Ljc5NkM5LjYyNSA2LjkzMjMzIDguNzExNSA3Ljg1NCA3LjU4MzMzIDcuODU0Wk0yMy4zMzMzIDIyLjE2NjdIMTkuODMzM1YxNS42Mjg3QzE5LjgzMzMgMTEuNjk5MyAxNS4xNjY3IDExLjk5NjggMTUuMTY2NyAxNS42Mjg3VjIyLjE2NjdIMTEuNjY2N1Y5LjMzMzMzSDE1LjE2NjdWMTEuMzkyNUMxNi43OTY1IDguMzc1NSAyMy4zMzMzIDguMTUyNjcgMjMuMzMzMyAxNC4yODEyVjIyLjE2NjdaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjAiIHkxPSIwIiB4Mj0iMjgiIHkyPSIyOCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNzdCREZGIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzBFNEVGRiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgLinkedin as ReactComponent };